import { ArrowCounterClockwise } from '@phosphor-icons/react';

export default ArrowCounterClockwise;
